export default {
  steps: {
    instruction: 'Instrukce',
    on: 'Na',
    step: 'kroku',
    gotoStep: 'Přejít na krok'
  }
}
